<template>
  <div class="custom-empty">
    <slot name="img">
      <img class="empty-img" src="@/assets/images/empty2.png" alt="img" />
    </slot>
    <slot>
      <div class="empty-text">暂无数据</div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'Empty2',
  props: {},
  components: {},
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.custom-empty {
  width: 350px;
  height: auto;
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: center;
  overflow: hidden;
  .empty-img {
    width: 100%;
  }
  .empty-text {
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #999999;
    height: 20px;
    line-height: 20px;
    text-align: center;
  }
  > span {
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #999999;
    height: 20px;
    line-height: 20px;
    display: block;
  }
}
</style>
